import CreationToolError from 'creation/src/creation-tools/types/error'
import { createContext } from 'react'

export type WelcomeContextValue = {
    error?: CreationToolError
    errorSource?: File | string
    isLoading: boolean
    setError: (error?: CreationToolError) => void
    setErrorSource: (source?: File | string) => void
    setIsLoading: (isLoading: boolean) => void
}

/**
 * Legacy structural reference: components/welcome/context.ts
 * (`CreationToolsWelcomeContext`).
 *
 * Legacy defaults this to `{} as Props` (an unsafe cast — any read without a
 * provider crashes). Defaulted here to real no-ops instead, because two
 * existing specs render descendants of this context without a provider:
 * buttons.spec.tsx (`FileButton`, via `WelcomeButtons`) and
 * url-input.spec.tsx (`WelcomeUrlInput`) both predate `WelcomeShell` and
 * wrap only `CreationStoreProvider`. A blind cast would make those crash the
 * moment either component's catch block called `setError`.
 */
export const WelcomeContext = createContext<WelcomeContextValue>({
    error: undefined,
    errorSource: undefined,
    isLoading: false,
    setError: () => {},
    setErrorSource: () => {},
    setIsLoading: () => {},
})
